__turbopack_context__.v({
  "compliance-overlay-text": "style-module-scss-module___AJypW__compliance-overlay-text",
  "component": "style-module-scss-module___AJypW__component",
});
